import { render, staticRenderFns } from "./AttendanceStudentCreate.vue?vue&type=template&id=647f659b"
import script from "../../controllers/attendance_student/attendance-student-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/attendance_student/attendance-student-create.js?vue&type=script&lang=js&external"
import style0 from "./AttendanceStudentCreate.vue?vue&type=style&index=0&id=647f659b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports